module.exports = __webpack_public_path__ + "assets/media/data-integrations-bot.8e0341fb.mp4";